import { ChangeDetectorRef, Component, OnInit, ViewChild, Input, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ControlUser } from '../model/controlUser';
import { DevicePilomat } from '../model/devicePilomat';
import { UserService } from '../service/user.service';
import { DeviceService } from 'src/app/service/device.service';
import { Log } from '../util/log';
import { Subscription } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { AccessMethods } from '../model/accessMethods';
import { DevicePermissionDialogEditorComponent } from '../device-permission-dialog-editor/device-permission-dialog-editor.component';

import { Overlay } from "@angular/cdk/overlay";
import { UserPermissions } from '../model/userPermissions';
import { UserPermissionsList } from '../model/userPermissionsList';

import { DateHelper } from '../util/dateHelper';
import { UserOwnerRel } from '../model/userOwnerRel';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { Group } from '../model/group';
import { UserOwnerRelData } from '../model/userOwnerRelData';
import { AppComponent } from '../app.component';
import { StringHelper } from '../util/stringHelper';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.css']
})
export class AddUserComponent implements OnInit {

  @ViewChild('adduserloader', { static: true }) loader;
  @Input() accessMethods: AccessMethods;

  userPermissions = new Map();
  previousPermissions: UserPermissions;

  addUserForm = new FormGroup({
    name: new FormControl(''),
    description: new FormControl(''),
    group: new FormControl(''),
  });

  username: string = "";
  description: string = "";
  groupSelected: boolean = false;
  usergroup: Group = new Group();
  userUid: string;
  owner: ControlUser;
  ownerUid: string;
  activationCode: string;
  userOwnerId: number;
  userCreated: boolean = false;
  userActivated: boolean = false;
  userEmailAddress: string = "";
  deviceList: DevicePilomat[];
  groupslist: Group[] = [];
  noGroup: Group;
  initialGroupId: number;

  mapString: string = $localize`:@@useradd_map:Mappa`;
  listString: string = $localize`:@@useradd_list:Lista`;


  newUsersTotal: number = 2500;
  newUsersCurrent: number = 5;


  usernameError: boolean = false;
  groupError: boolean = false;
  expiredPermissionsError: boolean = false;

  devicesWithExpiredPermissions: string[] = [];

  createdUserSubscription: Subscription;
  updatedUserSubscription: Subscription;
  updatedAcccessMethodsSubscription: Subscription;
  updatedUserPermissionsSubscription: Subscription;

  // Uso un'unico check sia per Service che per Alias senza permessi
  canUserEdit: boolean = false;

  //uso il check per verificare se oscurare i dati
  isUserService: boolean = false;

  constructor(
    public appComponent: AppComponent,
    private deviceService: DeviceService,
    private userService: UserService,
    private cdRef: ChangeDetectorRef,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router,
    private overlay: Overlay
  ) {

  }

  async ngOnInit(){

    Log.debug("ngOnInit")

    this.loader.showLoading();

    this.canUserEdit = await this.canUserEditCheck();

    let urlOwnerUid = this.route.snapshot.paramMap.get('ownerUid');

    this.userService.getMe().subscribe((owner) => {
      this.owner = owner;

      if (!urlOwnerUid) {
        this.ownerUid = owner.uid;
      } else {
        this.ownerUid = urlOwnerUid;
      }

      this.cdRef.detectChanges();
    });

    Log.debug("\n\n\n\n ownerUid is:");
    Log.debug(this.ownerUid);

    this.userOwnerId = parseInt(this.route.snapshot.paramMap.get('uid'));


    // this.userOwnerId = parseInt(this.route.snapshot.paramMap.get('uid'));
    this.noGroup = new Group();
    this.noGroup.name = $localize`:@@useradd_no_group:Nessuno`;
    this.noGroup.groupId = 0;
    this.getDeviceList();
  }

  ngOnDestroy(): void {
    if (this.updatedUserSubscription) {
      this.updatedUserSubscription.unsubscribe();
    }

    if (this.createdUserSubscription) {
      this.createdUserSubscription.unsubscribe();
    }

    if (this.updatedAcccessMethodsSubscription) {
      this.updatedAcccessMethodsSubscription.unsubscribe();
    }

    if (this.updatedUserPermissionsSubscription) {
      this.updatedUserPermissionsSubscription.unsubscribe();
    }
  }

  ngAfterViewInit() {
  }

  async canUserEditCheck() {

    const isAlias = await this.appComponent.isAlias();

    if (isAlias) {
      // se è Alias verifico se può modificare
      return await this.checkAliasPermissions("UserEdit");
    } else {
      //se non è Alias verifico se è Service
      if (this.appComponent.isService()) {
        // controllo per censura dati
        this.isUserService = true;
        return false;
      } else {
        // se non è né Alias né Service allora può modificare
        return true
      }
    }
  }

  getUserData() {
    if (this.userOwnerId) {
      this.userCreated = true;
      this.getUserOwnerRel();
    } else {
      setTimeout(() => {
        this.loader.hideLoading();
      }, 500);
    }
  }

  createUser() {
    if (this.userCreated) {

      Log.debug(" \n\n\n\n this.userCreated true");
      Log.debug(this.userCreated);

      if (!this.expiredPermissionsError) {
        this.groupError = false;
        this.usernameError = false;

        if (!this.username || this.username == "") {
          this.usernameError = true;
        } else if (!this.usergroup.name) {
          this.groupError = true;
        } else {
          let selectedDevices: boolean = false;

          this.deviceList.forEach(function (device) {
            if (device.selected == true) {
              selectedDevices = true;
              return null;
            }
          });

          if (!selectedDevices) {
            let message = $localize`:@@useradd_no_device_selected:Nessun dispositivo selezionato`;
            let header = $localize`:@@useradd_no_device_selected_warning:Attenzione`;
            let confirmMessage = $localize`:@@useradd_no_device_selected_continue:Prosegui`;
            let cancelMessage = $localize`:@@useradd_no_device_selected_cancel:Annulla`;


            const scrollStrategy = this.overlay.scrollStrategies.reposition();

            const dialogRef = this.dialog.open(ConfirmDialogComponent, {
              width: "350px",
              data: { message, header, confirmMessage, cancelMessage },
              scrollStrategy,
            });

            dialogRef.afterClosed().subscribe((response) => {
              if (response) {
                this.saveUser();
              }
            });
          } else {
            this.saveUser();

          }
        }
      }
    } else {


      Log.debug(" \n\n\n\n this.userCreated false");
      Log.debug(this.userCreated);

      this.saveUser();
    }
  }

  saveUser() {

    if (!this.userOwnerId) {

      Log.debug(" \n\n\n\n this.userCreated false");
      Log.debug(this.userOwnerId);

      // l'utente non esiste va creato

      this.loader.showLoading();
      let userOwnerRelToPut = new UserOwnerRelData();
      userOwnerRelToPut.name = this.username;
      userOwnerRelToPut.description = this.description;
      userOwnerRelToPut.groupId = this.usergroup.groupId;

      this.createdUserSubscription = this.userService.createUserOwnerRel(userOwnerRelToPut, this.ownerUid).subscribe((response) => {
        this.loader.hideLoading();
        this.router.navigate(['add-user/' + response.id]);
      }, (err) => {
        Log.debug(err);
      });

    } else {
      Log.debug(" \n\n\n\n this.userCreated true");
      Log.debug(this.userOwnerId);

      // l'utente esiste e va aggiornato
      this.updateUserBegin();
    }
  }

  // loadWithUsersRec() {

  //   let newUserPermissionsJSON = {
  //     "startDate": "2021-12-27T23:00:00Z",
  //     "expirationDate": "2022-01-27T23:00:00Z",
  //     "startDateDate": "2021-12-27T23:00:00.000Z",
  //     "expirationDateDate": "2022-01-27T23:00:00.000Z",
  //     "timeMask": "111111111111111111111111111111111111111111111111",
  //     "dayMask": 127,
  //     "creatorUid": "0wXLXGn4luWZs2mW1YMpTuGqxbH2",
  //     "serial": "3",
  //     "timeZone": "Europe/Rome",
  //     "timeSlots": []
  //   };
  //   let newUserPermissions = new UserPermissions();
  //   newUserPermissions.deserialize(newUserPermissionsJSON);

  //   let newUserPermissionsList = new UserPermissionsList();
  //   newUserPermissionsList.permissions.push(newUserPermissions);


  //   let newUsername = "AutoUser";
  //   newUsername = newUsername.concat(this.newUsersCurrent.toString());

  //   this.userService.createUserOwnerRel(newUsername, 0, this.ownerUid).subscribe((response) => {
  //     let newUserOwnerId = response.id;
  //     setTimeout(() => {
  //       Log.debug("Created user: " + newUsername);
  //       this.userService.updateUserPermissions(newUserPermissionsList, newUserOwnerId).subscribe((response) => {
  //         setTimeout(() => {
  //           Log.debug("updated permissions of: " + newUsername);
  //           this.newUsersCurrent++;
  //           if (this.newUsersCurrent < this.newUsersTotal) {
  //             this.loadWithUsersRec();
  //           }
  //         }, 2500)
  //       }, (err) => {
  //         Log.debug(err);
  //         this.loader.showError();
  //       });
  //     }, 2500)
  //   }, (err) => {
  //     Log.debug(err);
  //   });

  // }

  // loadWithUsers() {
  //   this.loadWithUsersRec();
  // }


  isGroupSelected(event: any) {
    this.clearUserPermissions();
    if (this.usergroup.groupId != 0) {
      this.getGroupPermissions();
      this.groupSelected = true;
    } else {
      if (this.userOwnerId) {
        this.getUserPermissions();
        this.groupSelected = false;
        this.usergroup = this.noGroup;
      }
    }
  }

  getDeviceList() {
    this.loader.showLoading();

    if (this.canUserEdit || this.isUserService) {

      this.deviceService.getOwnerDevices(this.ownerUid).subscribe(devices => {

        this.deviceList = devices;
        this.cdRef.detectChanges();
        this.getGroups();;

      }, error => {

        this.loader.hideLoading();
        this.loader.showError();

        this.cdRef.detectChanges();
      });

    } else {
      this.deviceService.getDevices().subscribe(
        (devices) => {
          this.deviceList = devices;
          this.cdRef.detectChanges();
          this.getGroups();
        },
        (error) => {
          this.loader.hideLoading();
          this.loader.showError();
          this.cdRef.detectChanges();
        }
      );
    }
  }

  onDeviceDeselected(device: DevicePilomat) {
    for (let i = 0; i < this.devicesWithExpiredPermissions.length; i++) {
      if (device.serial == this.devicesWithExpiredPermissions[i]) {
        this.devicesWithExpiredPermissions.splice(i, 1);
      }
    }
    if (this.devicesWithExpiredPermissions.length == 0) {
      this.expiredPermissionsError = false;
    }
    this.userPermissions.delete(device.serial);
    device.updateIcon();
  }

  onDeviceSelected(device: DevicePilomat) {

    let permissionsForDialogEditor: UserPermissions = new UserPermissions();

    if (this.userPermissions.has(device.serial)) {
      permissionsForDialogEditor = this.userPermissions.get(device.serial);
    } else {
      permissionsForDialogEditor = null;
    }

    const scrollStrategy = this.overlay.scrollStrategies.reposition();

    const dialogRef = this.dialog.open(DevicePermissionDialogEditorComponent, {
      width: "700px",
      data: { permissions: permissionsForDialogEditor, serial: device.serial, previousPermissions: this.previousPermissions, ownerUid: this.ownerUid },
      scrollStrategy,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (!result) {
        if (this.userPermissions.has(device.serial)) {
          device.selected = true;
        } else {
          device.selected = false;
        }
        // if (result === undefined) {
        //   device.selected = false;
        //   device.updateIcon();
        // }
        // if (!result) {
        //   if (this.userPermissions.get(device.systemInfo.serial) === undefined) {
        //     if result is false and no permission exists than the dialog has been closed without saving and device has no permission saved
        //     device.selected = false;
        //     device.updateIcon();
        //   }
        // } else
        // if (result) {
      } else {
        // if result exists than the dialog has been closed saving new permissions
        device.selected = true;
        device.shortPermissions = result.permissions.getShortDescription();

        this.userPermissions.set(device.serial, result.permissions);
        this.previousPermissions = result.permissions;

        if (this.expiredPermissionsError) {
          let expiredPermissionsPresent = false;
          this.devicesWithExpiredPermissions = [];
          this.userPermissions.forEach((value: UserPermissions, key: string) => {
            if (value.expiredPermissions) {
              expiredPermissionsPresent = true;
              this.devicesWithExpiredPermissions.push(value.serial);
            }
          });
          if (!expiredPermissionsPresent) {
            this.expiredPermissionsError = false;
          }
        }
        device.updateIcon();
      }
    });
  }

  createOwner() {
    this.updateUserBegin();
    this.loader.hideLoading();
  }

  deleteUser() {
    // this.loadWithUsers();
    let message = $localize`:@@useradd_delete_subscription_confirm: Conferma eliminazione abbonamento`;
    let confirmMessage = $localize`:@@useradd_delete_subscription_confirm_yes: Conferma`;
    let cancelMessage = $localize`:@@useradd_delete_subscription_confirm_no: Annulla`;

    const scrollStrategy = this.overlay.scrollStrategies.reposition();

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "350px",
      data: { message, confirmMessage, cancelMessage },
      scrollStrategy,
    });

    dialogRef.afterClosed().subscribe((response) => {
      if (response) {
        this.userService.deleteUser(this.ownerUid, this.userOwnerId).subscribe((response) => {
          this.router.navigate(['users']);
        }, (err) => {
          Log.debug(err);
          this.loader.showError();
        });
      }
    });
  }

  getAccessMethods(methods: AccessMethods) {
    this.accessMethods = methods;
  }

  updateUserBegin() {

    Log.debug("this.description");
    Log.debug(this.description);

    this.loader.showLoading();

    this.updateUserAccessMethods();

  }

  updateUserAccessMethods() {
    this.updatedAcccessMethodsSubscription = this.userService.updateAccessMethods(this.accessMethods, this.userOwnerId).subscribe((response) => {

      this.updateUserPermissions();

    }, (err) => {
      Log.debug(err);
      this.loader.showError();
    });
  }

  updateUserPermissions() {
    if (this.usergroup.groupId == 0) {

      let permissionsList: UserPermissionsList = new UserPermissionsList;
      this.userPermissions.forEach((value: UserPermissions, key: string) => {

        // if device is not selcted the permission is not saved
        this.deviceList.forEach(device => {
          if (device.systemInfo.serial == key && device.selected) {
            permissionsList.permissions.push(value);
          }
        });
      });

      this.updatedUserPermissionsSubscription = this.updatedUserSubscription = this.userService.updateUserPermissions(permissionsList, this.userOwnerId).subscribe((response) => {

        this.updateUserOwnerRel();

      }, (err) => {
        Log.debug(err);
        this.loader.showError();
      });
    } else if (this.initialGroupId != this.usergroup.groupId) {
      this.getGroupPermissions();
      this.updateUserOwnerRel();
    } else {
      this.updateUserOwnerRel();
    }
  }


  updateUserOwnerRel() {
    let userOwnerRelToPut: UserOwnerRel = new UserOwnerRel();
    userOwnerRelToPut.name = this.username;
    userOwnerRelToPut.description = this.description;
    userOwnerRelToPut.id = this.userOwnerId;
    if (this.groupSelected) {
      userOwnerRelToPut.groupId = this.usergroup.groupId;
    } else {
      userOwnerRelToPut.groupId = 0;
    }

    this.updatedUserSubscription = this.userService.updateUserOwnerRel(userOwnerRelToPut, this.userOwnerId).subscribe((response) => {
      this.showUserUpdatedDialog();
      this.loader.hideLoading();
    }, (err) => {
      Log.debug(err);
      this.loader.showError();
    });
  }

  showUserUpdatedDialog() {
    let message = $localize`:@@useradd_user_updated_successfully:Utente aggiornato correttamente`;

    const scrollStrategy = this.overlay.scrollStrategies.reposition();

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "350px",
      data: { message },
      scrollStrategy,
    });
  }

  getUserOwnerRel() {
    const obs = this.userService.getUserOwnerRel(this.userOwnerId);
    obs.subscribe((userOwnerRel) => {
      if (userOwnerRel.user) {

        Log.debug("\n\n\nuserOwnerRel");
        Log.debug(userOwnerRel);
        Log.debug(userOwnerRel.description);

        this.userActivated = true;
        this.userEmailAddress = userOwnerRel.user.email;
        this.activationCode = userOwnerRel.activationCode;
        this.userUid = userOwnerRel.userUid;

      }
      if (userOwnerRel.groupId != 0) {

        for (let i = 0; i < this.groupslist.length; i++) {
          if (this.groupslist[i].groupId == userOwnerRel.groupId) {

            this.usergroup = this.groupslist[i];
            this.groupSelected = true;
            break;
          }
        }
      } else {
        this.usergroup = this.noGroup;
        this.groupSelected = false;
      }
      this.initialGroupId = userOwnerRel.groupId;

      if (this.groupSelected) {
        this.getGroupPermissions();
      } else {
        this.getUserPermissions();
      }
      this.username = userOwnerRel.name;
      this.description = userOwnerRel.description;

      if (this.isUserService) {
        this.username = StringHelper.censorString(this.username);
        this.userEmailAddress = StringHelper.censorString(this.userEmailAddress);
        this.activationCode = StringHelper.censorString(this.activationCode);
      }

    });
  }

  async checkAliasPermissions(feature: string): Promise<boolean> {
    return this.userService.checkAliasPermissions(feature);
  }

  getGroups() {
    this.groupslist = [];
    const obs = this.userService.getOwnerGroups(this.ownerUid);
    obs.subscribe(data => {
      this.groupslist.push(this.noGroup);
      for (let i = 0; i < data.length; i++) {
        this.groupslist.push(data[i]);
      }
      this.getUserData();
    });
  }

  getUserPermissions() {
    // this.loader.showLoading();
    this.expiredPermissionsError = false;
    this.devicesWithExpiredPermissions = [];
    this.userPermissions.clear();
    const obs = this.userService.getUserPermissions(this.userOwnerId);
    obs.subscribe((getPermissionsData) => {

      setTimeout(() => {
        this.loader.hideLoading();
      }, 500);

      for (let i = 0; i < getPermissionsData.length; i++) {

        this.userPermissions.set(getPermissionsData[i].serial, getPermissionsData[i]);

        for (let j = 0; j < this.deviceList.length; j++) {
          if (this.deviceList[j].serial == getPermissionsData[i].serial) {

            this.deviceList[j].shortPermissions = getPermissionsData[i].getShortDescription();
            this.deviceList[j].selected = true;
            if (getPermissionsData[i].expiredPermissions) {
              this.expiredPermissionsError = true;
              this.devicesWithExpiredPermissions.push(getPermissionsData[i].serial);
            }
            break;
          }
        }
        let selectedDevices = [];
        let unSelectedDevices = [];
        for (let i = 0; i < this.deviceList.length; i++) {
          if (this.deviceList[i].selected) {
            selectedDevices.push(this.deviceList[i]);
          } else {
            unSelectedDevices.push(this.deviceList[i]);
          }
        }
        this.deviceList = [];
        this.deviceList = this.deviceList.concat(selectedDevices, unSelectedDevices);
      }
    });

  }


  getGroupPermissions() {
    // this.loader.showLoading();
    this.expiredPermissionsError = false;
    this.devicesWithExpiredPermissions = [];
    this.userPermissions.clear();
    const obs = this.userService.getGroupPermissions(this.usergroup.groupId, this.ownerUid);
    obs.subscribe((getGroupPermissionsData) => {
      setTimeout(() => {
        this.loader.hideLoading();
      }, 500);

      for (let i = 0; i < getGroupPermissionsData.length; i++) {

        this.userPermissions.set(getGroupPermissionsData[i].serial, getGroupPermissionsData[i]);

        for (let j = 0; j < this.deviceList.length; j++) {
          if (this.deviceList[j].serial == getGroupPermissionsData[i].serial) {

            this.deviceList[j].shortPermissions = getGroupPermissionsData[i].getShortDescription();
            this.deviceList[j].selected = true;
            if (getGroupPermissionsData[i].expiredPermissions) {
              this.expiredPermissionsError = true;
              this.devicesWithExpiredPermissions.push(getGroupPermissionsData[i].serial);
            }
            break;
          }
        }
      }
      let selectedDevices = [];
      let unSelectedDevices = [];
      for (let i = 0; i < this.deviceList.length; i++) {
        if (this.deviceList[i].selected) {
          selectedDevices.push(this.deviceList[i]);
        } else {
          unSelectedDevices.push(this.deviceList[i]);
        }
      }
      this.deviceList = [];
      this.deviceList = this.deviceList.concat(selectedDevices, unSelectedDevices);
    });
    this.cdRef.detectChanges();
  }

  clearUserPermissions() {
    for (let i = 0; i < this.deviceList.length; i++) {
      this.deviceList[i].selected = false;
      this.deviceList[i].shortPermissions = "-";
    }
  }
}
